<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'settingsEntry' })">工作室设置</em>
          <label
            ><i class="el-icon-arrow-right"></i>
            {{ title_prefix }}认证工作室</label
          >
        </div>
      </div>
      <div class="content-inner-wrap">
        <div class="applyProgressPanel" v-if="status === 1">
          <i class="icon-unpass"></i>
          <h3>审核未通过</h3>
          <p class="text reason">请提供有效的营业执照</p>
          <p class="text reason">
            若有任何疑问，请联系邮箱：developer@mini1.cn
          </p>
          <p class="text reason">
            更多详情请阅读<el-link
              href="https://mnweb.mini1.cn/activity/docs/operate_rule_V1_A20210520.html"
              target="_blank"
              type="primary"
              >《迷你世界工作室运营规范》</el-link
            >
          </p>
          <el-button
            id="applyAgain"
            class="largeBtn"
            type="primary"
            @click="status = 3"
            >重新申请</el-button
          >
        </div>
        <div class="applyProgressPanel" v-else-if="status === 2">
          <i class="icon-appling"></i>
          <h3>认证审核中</h3>
          <p class="text">
            官方会在5个工作日内审核您的申请<br />请留意邮箱内邮件或短信，若有疑问请联系QQ群797579276
          </p>
          <el-button
            @click="$router.push({ name: 'Studio' })"
            class="largeBtn"
            type="primary"
            >确定</el-button
          >
        </div>
        <div class="applyStepsPanel" v-else-if="(status = 3)">
          <el-steps :space="200" :active="step" finish-status="success">
            <el-step title="填写公司信息"></el-step>
            <el-step title="填写法人信息"></el-step>
            <el-step title="填写结算信息"></el-step>
          </el-steps>
          <div class="stepContent applyStep1" v-show="step === 0">
            <el-form
              :label-position="'right'"
              label-width="153px"
              :model="step1Form"
              :rules="step1Rule"
              ref="step1Form"
            >
              <el-form-item label="公司全称" prop="company_name">
                <el-input
                  placeholder="请填写公司全称"
                  v-model="step1Form.company_name"
                ></el-input>
              </el-form-item>
              <el-form-item label="营业执照注册号" prop="company_id">
                <el-input
                  placeholder="请填写营业执照注册号"
                  v-model="step1Form.company_id"
                ></el-input>
              </el-form-item>
              <el-form-item label="营业执照" prop="fileList">
                <my-el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :on-remove="s1FormHandleRemove"
                  :on-change="s1FormOnChange"
                  :file-list="step1Form.fileList"
                  :before-upload="onBeforeUpload"
                  name="image"
                  accept="image/png,image/jpeg,image/bmp"
                  list-type="picture"
                >
                  <el-button size="small" class="uploadBtn">
                    <i class="icon icon-upload"></i
                    ><span>上传文件</span></el-button
                  >
                  <div slot="tip" class="el-upload__tip">
                    <p>请上传公司营业执照照片或扫描件图片</p>
                    <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                  </div>
                </my-el-upload>
              </el-form-item>
            </el-form>
            <el-button
              class="largeCenterBtn"
              @click="handleNextClicked"
              type="primary"
              >下一步</el-button
            >
          </div>
          <div class="stepContent applyStep2" v-show="step === 1">
            <el-form
              :label-position="'right'"
              label-width="153px"
              :model="step2Form"
              :rules="step2Rule"
              ref="step2Form"
            >
              <el-form-item label="法人名字" prop="boss_name">
                <el-input
                  placeholder="请填写法人名字"
                  v-model="step2Form.boss_name"
                ></el-input>
              </el-form-item>
              <el-form-item label="法人身份证号" prop="boss_id">
                <el-input
                  placeholder="请填写法人身份证号"
                  v-model="step2Form.boss_id"
                ></el-input>
              </el-form-item>
              <el-form-item label="法人身份证信息" prop="fileList">
                <my-el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :on-remove="s2FormHandleRemove"
                  :on-change="s2FormOnChange"
                  :file-list="step2Form.fileList"
                  :before-upload="onBeforeUpload"
                  name="image"
                  accept="image/png,image/jpeg,image/bmp"
                  list-type="picture"
                >
                  <el-button size="small" class="uploadBtn">
                    <i class="icon icon-upload"></i
                    ><span>上传文件</span></el-button
                  >
                  <div slot="tip" class="el-upload__tip">
                    <p>请上传法人身份证正反面照片或扫描件图片</p>
                    <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                  </div>
                </my-el-upload>
              </el-form-item>
            </el-form>
            <div class="largeBtnGroup">
              <el-button
                class="largeCenterBtn"
                @click="handlePrevClicked"
                type="info"
                >上一步</el-button
              >
              <el-button
                class="largeCenterBtn"
                @click="handleNextClicked"
                type="primary"
                >下一步</el-button
              >
            </div>
          </div>
          <div class="stepContent applyStep3" v-show="step === 2">
            <el-form
              :label-position="'right'"
              label-width="153px"
              :model="step3Form"
              :rules="step3Rule"
              ref="step3Form"
            >
              <el-form-item label="银行卡号" prop="bank_card">
                <el-input
                  placeholder="请填写公司的银行卡号"
                  v-model="step3Form.bank_card"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属银行" prop="bank_name">
                <el-input
                  placeholder="请填写公司的银行卡所属银行"
                  v-model="step3Form.bank_name"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属支行" prop="bank_branch">
                <el-input
                  placeholder="请填写公司的银行卡所属支行"
                  v-model="step3Form.bank_branch"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话" prop="phone">
                <el-input
                  placeholder="请填写公司的银行卡联系电话"
                  v-model="step3Form.phone"
                ></el-input>
              </el-form-item>
              <el-form-item label="账户凭证" prop="fileList">
                <my-el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :on-remove="s3FormHandleRemove"
                  :on-change="s3FormOnChange"
                  :file-list="step3Form.fileList"
                  :before-upload="onBeforeUpload"
                  name="image"
                  accept="image/png,image/jpeg,image/bmp"
                  list-type="picture"
                >
                  <el-button size="small" class="uploadBtn">
                    <i class="icon icon-upload"></i
                    ><span>上传文件</span></el-button
                  >
                  <div slot="tip" class="el-upload__tip">
                    <p>
                      请上传以公司名义开立的基本存款账户信息凭证，如开户许可证照片等
                    </p>
                    <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                  </div>
                </my-el-upload>
              </el-form-item>
            </el-form>
            <div class="largeBtnGroup">
              <el-button
                class="largeCenterBtn"
                @click="handlePrevClicked"
                type="info"
                >上一步</el-button
              >
              <el-button
                class="largeCenterBtn"
                @click="handleNextClicked"
                type="primary"
                >提交信息</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyUpload from '../../../../components/MyUpload.vue';
import {
  studioRequestVip,
  studioChangeVip,
  getStudioDetail,
  checkStudioRegisterStatus,
} from '@/api/studio';
import {
  UPLOAD_URL,
  isValidTel,
  isValidPhone,
  isValidFileSize,
} from '../../CONST';
export default {
  components: {
    [MyUpload.name]: MyUpload,
  },
  data() {
    const validatorContact = (rule, value, callback) => {
      if (isValidTel(value) || isValidPhone(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的联系方式'));
      }
    };
    return {
      studioBaseInfo: null,
      title_prefix: '成为',
      uploadUrl: UPLOAD_URL,
      // 1, 审核未通过； 2, 审核中； 3, 审核已通过
      status: 1,
      step: 0,
      step1Form: {
        company_name: '',
        company_id: '',
        fileList: [],
      },
      step2Form: {
        boss_name: '',
        boss_id: '',
        fileList: [],
      },
      step3Form: {
        bank_card: '',
        bank_name: '',
        bank_branch: '',
        phone: '',
        fileList: [],
      },
      step1Rule: {
        company_name: [
          { required: true, message: '请填写公司名称', trigger: 'blur' },
          {
            min: 4,
            max: 50,
            message: '长度在 4 到 50 个字符',
            trigger: 'blur',
          },
        ],
        company_id: [
          {
            required: true,
            message: '请填写营业执照注册号',
            trigger: 'blur',
            pattern: /(^[A-Za-z0-9_]{15}$)|(^[A-Za-z0-9_]{18}$)/,
          },
        ],
        fileList: [
          {
            type: 'array',
            required: true,
            message: '请上传公司营业执照照片或扫描件图片',
            trigger: 'change',
          },
        ],
      },
      step2Rule: {
        boss_name: [
          { required: true, message: '请填写法人名字', trigger: 'blur' },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'blur',
          },
        ],
        boss_id: [
          {
            required: true,
            message: '请填写法人身份证号码',
            trigger: 'blur',
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          },
        ],
        fileList: [
          {
            type: 'array',
            required: true,
            message: '请上传公司法人身份证正反面照片',
            trigger: 'change',
          },
        ],
      },
      step3Rule: {
        bank_card: [
          {
            required: true,
            message: '请填写银行卡号码',
            trigger: 'blur',
            max: 25,
            min: 8,
          },
        ],
        bank_name: [
          { required: true, message: '请填写银行名称', trigger: 'blur' },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'blur',
          },
        ],
        bank_branch: [
          {
            required: true,
            message: '请填写所属银行支行名称',
            trigger: 'blur',
          },
          {
            min: 2,
            max: 50,
            message: '长度在 2 到 50 个字符',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            validator: validatorContact,
            message: '请填写公司的银行卡联系电话',
            trigger: 'blur',
          },
        ],
        fileList: [
          {
            type: 'array',
            required: true,
            message: '请上传以公司名义开立的银行卡正面照片或扫描件照片',
            trigger: 'change',
          },
        ],
      },
    };
  },
  created() {
    checkStudioRegisterStatus({ json: 1 }).then(res => {
      let { is_vip_audit_approving, is_vip_audit_rejected } = res.data;
      if (is_vip_audit_rejected) {
        this.status = 1;
      } else if (is_vip_audit_approving) {
        this.status = 2;
      } else {
        this.status = 3;
      }
    });
  },
  async mounted() {
    this.getStudioInfo();
    const IS_UPDATE = this.$route.params.requestType === 'update';
    if (IS_UPDATE) {
      this.title_prefix = '修改';
      let {
        company_name,
        company_id,
        company_image,
        boss_name,
        boss_id,
        boss_id_front,
        boss_id_back,
        bank_card,
        bank_name,
        bank_branch,
        phone,
        bank_card_front,
      } = this.studioBaseInfo;
      this.step1Form = {
        company_name,
        company_id,
        fileList: [{ name: '营业执照', url: company_image }],
      };
      this.step2Form = {
        boss_name,
        boss_id,
        fileList: [
          { name: '身份证正面', url: boss_id_front },
          { name: '身份证反面', url: boss_id_back },
        ],
      };
      this.step3Form = {
        bank_card,
        bank_name,
        bank_branch,
        phone,
        fileList: [{ name: '银行卡正面照', url: bank_card_front }],
      };
    }
  },
  methods: {
    async getStudioInfo() {
      let studioBaseInfo = sessionStorage.getItem('studioBaseInfo');
      if (studioBaseInfo) {
        this.studioBaseInfo = JSON.parse(studioBaseInfo);
      } else {
        const res = await getStudioDetail({ json: 1 });
        this.studioBaseInfo = res.data;
        sessionStorage.setItem(
          'studioBaseInfo',
          JSON.stringify(this.studioBaseInfo),
        );
      }
    },
    onBeforeUpload(file) {
      return isValidFileSize(file.size, () =>
        this.$message.error('请限制文件大小在10M以内'),
      );
    },
    handleNextClicked() {
      const stepForm = `step${1 + this.step}Form`;
      if (!this.studioBaseInfo) this.getStudioInfo();
      const requestFn = this.studioBaseInfo.vip
        ? studioChangeVip
        : studioRequestVip;
      // const requestFn = studioRequestVip;
      this.$refs[stepForm].validate((valid, obj) => {
        console.log('validate', valid, obj);
        if (valid) {
          if (this.step === 1) {
            if (this.step2Form.fileList.length < 2)
              return this.$message.error('请上传公司法人身份证正反面照片');
          }
          if (this.step === 2) {
            if (this.step2Form.fileList.length < 2)
              return this.$message.error('请上传公司法人身份证正反面照片');
            let { company_name, company_id } = this.step1Form;
            let company_image = this.step1Form.fileList[0].url;
            let { boss_name, boss_id } = this.step2Form;
            let boss_id_front = this.step2Form.fileList[0].url;
            let boss_id_back = this.step2Form.fileList[1].url;
            let { bank_card, bank_name, bank_branch, phone } = this.step3Form;
            let bank_card_front = this.step3Form.fileList[0].url;
            requestFn({
              company_name,
              company_id,
              company_image,
              boss_name,
              boss_id,
              boss_id_front,
              boss_id_back,
              bank_card,
              bank_name,
              bank_branch,
              phone,
              bank_card_front,
              json: 1,
            }).then(res => {
              if (res.code === 0) {
                this.step++;
                this.$message.success('提交申请成功，请等待审核后生效');
                this.status = 2;
              }
            });
          } else {
            this.step++;
          }
        } else {
          return false;
        }
      });
    },
    handlePrevClicked() {
      this.step--;
    },
    s1FormOnChange(file) {
      this.formOnchange(file, 1);
    },
    s2FormOnChange(file) {
      this.formOnchange(file, 2);
    },
    s3FormOnChange(file) {
      this.formOnchange(file, 3);
    },
    formOnchange(file, index) {
      let { status, response, name } = file;
      if (status === 'success' && response.code === 200) {
        if (index === 2) {
          if (this.step2Form.fileList.length > 2) {
            this.step2Form.fileList.shift();
          }
          this[`step${index}Form`].fileList.push({
            name,
            url: response.data.image.cdn_url,
          });
        } else {
          this[`step${index}Form`].fileList = [
            { name, url: response.data.image.cdn_url },
          ];
        }
      }
    },
    s1FormHandleRemove(file) {
      this.formHandleRemove(file, 1);
    },
    s2FormHandleRemove(file) {
      this.formHandleRemove(file, 2);
    },
    s3FormHandleRemove(file) {
      this.formHandleRemove(file, 3);
    },
    formHandleRemove(file, index) {
      let { name } = file;
      let rmIndex = -1;
      const stepForm = `step${index}Form`;
      this[stepForm].fileList.forEach((val, index) => {
        if (val.name === name) rmIndex = index;
      });
      if (rmIndex > -1) {
        this[stepForm].fileList.splice(rmIndex, 1);
      }
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .icon-unpass,
  .icon-appling {
    display: block;
    width: 120px;
    height: 120px;
    margin: 154px auto 48px;
    background: url('../../../../assets/images/icon-unpass.svg') 0 0 no-repeat;
    background-size: 120px;
  }
  .icon-appling {
    background-image: url('../../../../assets/images/icon-appling.svg');
  }
  h3 {
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #262626;
    line-height: 26px;
    text-align: center;
    margin-bottom: 24px;
  }
  .text {
    font-size: 16px;
    line-height: 22px;
    color: #8c8c8c;
    text-align: center;
    .el-link {
      color: #2b6ddf;
    }
  }
  .largeBtn {
    display: block;
    margin: 168px auto 40px;
    width: 200px;
    height: 50px;
    background: #fd9b21;
    border-radius: 8px;
    font-size: 20px;
  }
  .applyStepsPanel {
    width: 678px;
    margin: auto;
    ::v-deep .el-form {
      width: 598px;
      margin: auto;
      .el-form-item__label {
        font-size: 16px;
        color: #262626;
      }
      .el-input__inner {
        width: 359px;
      }
    }
    ::v-deep .el-steps {
      margin: 30px auto 72px;
      position: relative;
      left: 40px;
    }
    ::v-deep .el-step {
      margin-right: 20px !important;
      width: 206px !important;
      flex-basis: 206px !important;
    }
    ::v-deep .el-step__title {
      font-size: 16px;
      line-height: 26px;
      // height: 24px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 24px;
      margin: auto;
      background: #fff;
      padding: 0 20px 0 6px;
    }
    ::v-deep .el-step__title.is-success {
      color: #fd9b21;
    }
    ::v-deep .el-step__head {
      position: relative;
      &.is-success {
        color: #fd9b21;
        border-color: #fd9b21;
      }
    }
    ::v-deep .el-form-item__content {
      margin-left: 181px !important;
    }
  }
}
</style>
<style lang="scss">
.container .block .content-inner-wrap .applyStepsPanel {
  .applyStep1 {
    .el-upload-list--picture {
      .el-upload-list__item {
        width: 100px;
        height: 140px;
      }
      .el-upload-list__item-thumbnail {
        width: 100px;
        height: 140px;
      }
    }
  }
  .applyStep2,
  .applyStep3 {
    .el-upload-list--picture {
      display: flex;
      .el-upload-list__item {
        width: 111px;
        height: 70px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 18px;
      }
      .el-upload-list__item-thumbnail {
        width: 111px;
        height: 70px;
        border-radius: 8px;
      }
    }
  }
}
</style>
